import React, { useEffect, useRef, useState } from "react";
import { Dropdown } from "react-bootstrap";
import "./dropDown.css";
import DropdownArrow from "../../assets/images/dropdownArrow.svg";

const DropDownSearch = ({
  list,
  selectedItem,
  setSelectedItem,
  IsSearch = false,
  disabled,
  categoryRequired,
  isEdit,
}) => {
  const [showDropdownList, setShowDropdownList] = useState(false);
  const [dropdownList, setDropdownList] = useState(list);
  const [searchKeyWord, setSearchKeyWord] = useState("");
  const [nodataFound, setNoDataFound] = useState(false);
  const ref = useRef();

  const searchList = () => {
    const result = list.filter((item) => item.includes(searchKeyWord));
    if (result.length == 0) {
      setNoDataFound(true);
    } else {
      setNoDataFound(false);
      return result;
    }
  };

  useEffect(() => {
    const result = searchList();
    setDropdownList(result);
  }, [searchKeyWord]);

  const handleSearchChange = (e) => {
    const inputValue = e.target.value;
    // Use a regular expression to check if the input contains only numbers
    const isNumber = /^\d+$/.test(inputValue);

    if (isNumber || inputValue === "") {
      setSearchKeyWord(inputValue);
    }
  };
  return (
    <Dropdown
      disabled={disabled}
      className={
        categoryRequired == false ? "drop-item" : "drop-item error-alert"
      }
      align="end"
    >
      <Dropdown.Toggle variant="secondary" id="dropdown-basic">
        {selectedItem}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {IsSearch == true && !isEdit ? (
          <input
            className="search-filter"
            onChange={handleSearchChange}
            placeholder="Search..."
            value={searchKeyWord}
          />
        ) : null}
        {nodataFound == true && isEdit ? (
          <div className="invalid-msg">No data found</div>
        ) : null}

        {dropdownList?.map((item, index) => {
          return (
            <Dropdown.Item
              href="#"
              key={index}
              onClick={() => {
                setSelectedItem(item), setShowDropdownList(false);
                setSearchKeyWord("");
              }}
            >
              {item}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropDownSearch;
